<ng-container *transloco="let t">

  <app-carousel [images]="[images[0]]" bannerAlt="We trace you race"
                bannerImage="assets/img/cpr_transparent.png" [showButton]="true">
    <div slot="content">
      <div class="search-box">
        <div class="text-center">
          <h2 class="mb-3 text-white d-none d-lg-block">
            {{ t('carousel.search.races') }}
          </h2>
          <app-search-bar-races/>
        </div>
      </div>
    </div>
    <div slot="button">>> Races Map</div>

  </app-carousel>

  <section class="container-fluid next-race-section py-5">
    <div class="container">
      <div class="mb-4">
        <div class="row row-cols-1 row-cols-xl-2 d-flex align-items-center">
          <div class="col">
            <h2> {{ t(headerTitleKey) }} </h2>
          </div>
        </div>
      </div>
      <!-- <div *ngIf="!showFavorites()">
        <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3" *ngIf="favoriteItems.length ?? 0 > 0; else emptyState">
          <div class="col mb-4" *ngFor="let item of favoriteItems">
            <app-event-grid-item-with-image *ngIf="isEventItem(item)" (click)="goToEventDetailsPage(getEventItem(item))"
              [eventItem]="getEventItem(item)" [languages]="languages" />
                        <app-race-grid-item *ngIf="!isEventItem(item)" [race]="getRaceItem(item)"/>
          </div>
        </div>
      </div> -->
      @if (showFavorites()) {
        <div>
          @if (favoriteItems.length ?? 0 > 0) {
            <div class="row row-cols-1 row-cols-lg-2 row-cols-xl-3">
              @for (item of favoriteItems;let last = $last;track item) {
                <div class="col" [class.mb-4]="!last">
                  <app-event-grid-item-with-image-small [eventItem]="item" [countries]="countries" [isOnWishList]="true"
                                                        [languages]="languages"/>
                </div>
              }
              <!-- <app-event-grid-item-with-image (click)="goToEventDetailsFavoritesPage(getEventItem(item))"
                  [eventItem]="getEventItem(item)" [languages]="languages" /> -->
            </div>
          } @else {
            <app-empty-state/>
          }
        </div>
      }
      <div class="text-center py-2">
        <div class="d-inline-block">
          @if (hasMore) {
            <app-button label]="t('app.common.load.more')" [btnClass]="'btn-primary-red btn-large'"
                        (onClick)="loadMore()"/>
          }
        </div>
      </div>
    </div>
  </section>
</ng-container>
